import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import markup from "ulysses/widgets/masterresult.html";
import "../widgets";

$(document).ready(function() { $(markup).appendTo($("body")); });

uly.master_result_refresh = null;
uly.current_grid = null;
ko.bindingHandlers.masterresult = {
    "init":function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.title(_("masterresult_loading", "loading..."));
        widget_model.icon("fa fa-tags");
        widget_model.show_header(false);
        var entity_data = ko.observable(null);
        $(elt).parent().data("widget_data", entity_data);
        var childContext = context.createChildContext({"widget_data":entity_data });
        ko.applyBindingsToDescendants(childContext, elt);
        uly.subscribe("attachments.uploaded", function(ev, payload) {
            if ($(elt).has(payload.elt)) {
                ko.bindingHandlers.masterresult.update(elt,va,allbindings,model,context);
            }
        }, elt);
        uly.subscribe("attachments.deleted", function(ev, payload) {
            if ($(elt).has(payload.elt)) {
                ko.bindingHandlers.masterresult.update(elt,va,allbindings,model,context);
            }
        }, elt);
        uly.subscribe("masterresult.refresh", function(ev, payload) {
            ko.bindingHandlers.masterresult.update(elt,va,allbindings,model,context);
        }, elt);

        ko.utils.domNodeDisposal.addDisposeCallback(elt, function () {
            // cleanup item
            entity_data(null);
        });

        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, allbindings, model, context) {
        uly.publish("widget.loading", elt);
        var data_obs = $(elt).parent().data("widget_data");
        var widget_model = ko.unwrap(va());
        var settings = ko.unwrap(widget_model.settings);
        var sub = $(elt).data("sub_token");
        if (sub) {
            uly.unsubscribeToChange(sub.id, sub.token);
            $(elt).data("sub_token",null);
        }
        //TODO: need to get the closest <page-ish> context
        var entity = ko.unwrap(uly.page.page_resource);

        if (entity) {
            var hal_entity = HalResource(entity);
            hal_entity.done(function(entity) {
                $(elt).data("sub_token", {"token":uly.subscribeToChange(entity.unique_id, function() {
                    uly.utils.throttle(elt, function() { uly.page.refresh_resource(); }, 500);
                    //uly.publish("masterresult.refresh", entity.unique_id);
                }, elt), "id":entity.unique_id});
            });
            var data = ko.toJS(entity);
            data = new uly.page.searchify_item(data);
            if (ko.unwrap(settings.expanded) || typeof ko.unwrap(settings.expanded) == "undefined") {
                data.collapsed(false);
            }
            var uid = ko.unwrap(data.unique_id);
            data.activate_entity = function(ui, ev) {
                var ev_tag = ev.target.tagName.toLowerCase();
                if(["a", "button", "input", "summary"].indexOf(ev_tag) < 0) {
                    uly.publish("page.activate.entity", uid);
                } else if (ev_tag === "input" || ev_tag === "summary")
                    return true;
            };
            data.is_active.dispose();
            data.is_active = ko.pureComputed(function() { return true; });
            uly.publish("search.result.master.show", data);
            if (typeof data_obs == "function") {
                data_obs(data);
            }
            uly.page.title(ko.unwrap(data.title));
            widget_model.title(data.title);
            uly.publish("widget.active", elt);
        } else {
            if (typeof data_obs == "function") {
                data_obs(null);
            }
        }
    }

};
ko.virtualElements.allowedBindings.masterresult = true;
